import React from 'react';

import logo from '../../assets/logo/logo.jpg';

import Stack from '@mui/material/Stack';
import { styled } from '@mui/material';

const StyledHeader = styled(Stack)(({ theme }) => ({
	backgroundColor: theme.palette.background
}));

const Header = () => {
	return (
		<StyledHeader
			p={2}
			direction='row'
			alignItems='center'
			justifyContent='end'
		>
			<img src={logo} alt='savvy logo' />
		</StyledHeader>
	);
};

export default Header;
